
import state from './state';
import Store from '../../base/index';


export default class Objects extends Store {
    constructor(model, ng){

        state.model = model;

        super({state, ng});
    }
}



// WEBPACK FOOTER //
// ./src/app/store/bookable-objects/objects/index.js